import { takeEvery, put, call, debounce } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import {
  addAddressError,
  addAddressSuccess,
  deleteAddressError,
  deleteAddressSuccess,
  updateAddressError,
  updateAddressSuccess,
} from "../features/address.slice";
import { baseInstance } from "../../service/instance";
import { ENDPOINTS } from "../../service/api";
import { toastError, toastSuccess } from "../../shared/util/toast.message";
import { MESSAGES } from "../../config/app";

function* deleteAddressSaga(action: any) {
  const { id, callBackSuccess, callBackFailure } = action?.payload;

  try {
    let res: AxiosResponse = yield call(
      baseInstance.post,
      ENDPOINTS?.PROXY,
      {
        method: "DELETE",
        url: process.env.REACT_APP_AUTH_BASE_URL + ENDPOINTS?.DELETE_ADDRESS + `/${id}`
      }

    );
    if (res.data.statuscode === 200) {
      let ress: any = res.data.data;
      yield put(deleteAddressSuccess(ress));
      toastSuccess(MESSAGES.deleteAddressSuccess);
      callBackSuccess();
    }
  } catch (err:any) {
    toastError(err.message);
    callBackFailure();
    yield put(deleteAddressError(err));
  }
}

function* addAddressSaga(action: any) {
  const { callBackSuccess, address } = action?.payload;
  // console.log("address in saga", address);
  try {
    let res: AxiosResponse = yield call(
      baseInstance.post,
      ENDPOINTS?.PROXY,
      {
        method: "POST",
        url: process.env.REACT_APP_AUTH_BASE_URL + ENDPOINTS?.ADD_ADDRESS,
        body: address
      }
    );
    if (res.data.statuscode === 200) {
      let ress: any = res.data.data;
      yield put(addAddressSuccess(ress));
      toastSuccess(MESSAGES.addAddressSuccess);
      callBackSuccess();
    }
  } catch (err:any) {
    toastError(err.message);
    yield put(addAddressError(err));
  }
}

function* updateAddressSaga(action: any) {
  const { id, callBackSuccess, address } = action?.payload;
  try {
    let res: AxiosResponse = yield call(
      baseInstance.post,
      ENDPOINTS?.PROXY,
      {
        method: "POST",
        url: process.env.REACT_APP_AUTH_BASE_URL + ENDPOINTS?.UPDATE_ADDRESS + `/${id}`,
        body: address
      }
    );
    if (res.data.statuscode === 200) {
      let ress: any = res.data.data;
      yield put(updateAddressSuccess(ress));
      toastSuccess(MESSAGES.updateAddressSuccess);
      callBackSuccess();
    }
  } catch (err:any) {
    toastError(err.message);
    yield put(updateAddressError(err));
  }
}

function* addressSaga() {
  yield takeEvery("addressStateSlice/deleteAddressById", deleteAddressSaga);
  yield takeEvery("addressStateSlice/addAddress", addAddressSaga);
  yield takeEvery("addressStateSlice/updateAddress", updateAddressSaga);
}

export default addressSaga;
